import { getCmsHost } from 'app/helpers/library/features';

export const makeBackToLinkProps = (formatMessage, { backToCmsPath, backToCmsTitle, currentLibrary }) => {
  const backToCmsHost = getCmsHost(currentLibrary);

  let backToLabel;
  let backToUrl;
  let isExternalLink;
  let screenReaderLabel;

  if (backToCmsHost && backToCmsPath) {
    const host = backToCmsHost.replace(/\/+$/, '');
    const path = backToCmsPath.replace(/^\/+/, '');

    backToUrl = `${host}/${path}`;
    backToLabel = backToCmsTitle || backToUrl;
    isExternalLink = true;
    screenReaderLabel = formatMessage(
      {
        defaultMessage: 'Back to {pageTitle}',
        id: 'sr_back_to_page_title'
      },
      {
        pageTitle: backToLabel
      }
    );
  } else {
    const backToPageTitle = formatMessage({ id: 'browse' });

    backToUrl = '/v2/browse';
    backToLabel = backToPageTitle;
    isExternalLink = false;
    screenReaderLabel = formatMessage(
      {
        defaultMessage: 'Back to {pageTitle}',
        id: 'sr_back_to_page_title'
      },
      {
        pageTitle: backToPageTitle
      }
    );
  }

  return {
    href: backToUrl,
    isExternalLink,
    label: backToLabel,
    screenReaderLabel
  };
};
